import Select from 'react-select';

const BrandSelect = ({ brands = [], selectedBrandId, onChange, isDisabled = false }) => {
    const options = (Array.isArray(brands) ? brands : []).map((brand) => ({
        value: brand._id,
        label: brand.name,
        isActive: brand.isActive,
    }));

    const selectedValue = options.find((option) => option.value === selectedBrandId) || null;

    const handleChange = (selectedOption) => {
        onChange(selectedOption ? selectedOption.value : null);
    };

    return (
        <div className="brand-select-wrapper">
            <Select
                isClearable
                options={options}
                value={selectedValue}
                onChange={handleChange}
                placeholder="Seleccione una marca (opcional)"
                isDisabled={isDisabled}
                className="basic-single-select"
                classNamePrefix="select"
                menuPortalTarget={document.body}
                styles={{
                    menuPortal: (base) => ({
                        ...base,
                        zIndex: 9999,
                    }),
                }}
                formatOptionLabel={(option) => (
                    <div className="d-flex justify-content-between align-items-center">
                        <span>{option.label}</span>
                        {option.isActive === false ? (
                            <small className="text-muted ms-2">(Inactiva)</small>
                        ) : null}
                    </div>
                )}
            />
        </div>
    );
};

export default BrandSelect;

